"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicLinkStyle = void 0;
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const dynamicLinkStyle = (color, hoverColor, disabled) => (0, core_1.css) `
    color: ${disabled ? styles_scss_1.default.silver : color};
    &:hover {
      color: ${disabled ? styles_scss_1.default.silver : hoverColor};
    };
    opacity: 0.9;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    pointer-events: ${disabled ? 'none' : 'auto'};
    &:active {
      opacity: 1;
    };
  `;
exports.dynamicLinkStyle = dynamicLinkStyle;
